import { useMemo } from 'react';

export function useCheckboxState(
  size: number,
  included: number,

  count?: number
) {
  const indeterminate = useMemo(() => {
    if (size > 0 || included > 0) return true;
    if (count && count > 0) return true;
    return false;
  }, [size, included, count]);

  return useMemo(() => ({ indeterminate }), [indeterminate]);
}
